/** Shared inventory light-theme tokens (mockup). */
export const INVENTORY_ACCENT = '#009EDA';
export const INVENTORY_LIGHT = {
  pageBg: '#F4F6FD',
  cardBg: '#FFFFFF',
  cardShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
  cardRadius: 16,
  textPrimary: '#0F172A',
  textSecondary: '#64748B',
  pillBorder: 'rgba(15, 23, 42, 0.12)',
  pillBg: '#FFFFFF',
  /** Same fill as product-page "Give us a ring" (`PRODUCT_DETAIL_ACTION_BTN_BG`). */
  pillActionBg: '#f5f7fc',
  searchBorder: 'rgba(0, 158, 218, 0.45)',
  divider: 'rgba(15, 23, 42, 0.08)',
};

/**
 * Vertical gap between filter card and slider card on light desktop.
 * Logged-in: also the flex gap between search card and in-flow app menu.
 */
export const INVENTORY_LIGHT_DESKTOP_CARD_GAP_PX = 16;

/** App menu control size — keep in sync with InventoryRouteLayout MenuIconButton. */
export const INVENTORY_APP_MENU_SIZE_PX = 50;
/** Fixed menu inset from viewport right (mobile / stacked inventory only). */
export const INVENTORY_APP_MENU_RIGHT_PX = 25;

/** Desktop inventory page padding (listView root). */
export const INVENTORY_PAGE_PADDING = '16pt';

/**
 * Logged-in mobile chrome (inventory / news / events): same height and fill as the
 * public TopBar — keep in sync with `HOME_TOP_BAR_HEIGHT_MOBILE_PX` / `HOME_TOP_BAR_BG`
 * (not imported to avoid a cycle). Share (left) + logo (center) + menu (right) sit
 * inside this bar; menu matches guest TopBar (`right: 24`, white icon, no circle).
 */
export const LOGGED_IN_MOBILE_TOP_BAND_HEIGHT_PX = 48;
export const LOGGED_IN_MOBILE_TOP_BAND_BG = '#1f242d';
export const LOGGED_IN_MOBILE_CHROME_SIDE_INSET_PX = 10;
export const LOGGED_IN_MOBILE_CHROME_ICON_COLOR = '#ffffff';
export const LOGGED_IN_MOBILE_CHROME_LOGO_SRC = '/static/news/1000containers-horizontal-white.svg';
export const LOGGED_IN_MOBILE_CHROME_LOGO_HEIGHT_PX = 30;
export const INVENTORY_LOGGED_IN_MOBILE_CHROME_HEIGHT_PX = LOGGED_IN_MOBILE_TOP_BAND_HEIGHT_PX;

export const isInventoryLight = (theme) => theme?.palette?.type === 'light';
